import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-dark text-white pt-4">
            {/* Main Footer Content */}
            <div className="container">
                <div className="row">
                    {/* About Us Section */}
                    <div className="col-md-6 mb-4">
                        <h5 className="text-uppercase mb-4" style={{ color: '#0dcaf0' }}>About Us</h5>
                        <p className="text-white">
                            Welcome to JALISTEP INTERNATIONAL LIMITED. We deal with water treatment 
                            equipment and chemicals. We stock, supply, install, commission, and service 
                            all equipment related to water treatment for industries, hospitals, 
                            pharmaceuticals, schools, hotels, residential, and commercial properties.
                        </p>
                    </div>

                    {/* Stay Connected Section */}
                    <div className="col-md-6 mb-4">
                        <h5 className="text-uppercase mb-4" style={{ color: '#0dcaf0' }}>Stay Connected</h5>
                        
                            <a href="#" className="me-3 text-white">
                                <img src="images/jalistep/fb.png" alt="Facebook" className="social-icon" style={{ width: '32px', height: '32px' }} />
                            </a>
                            <a href="#" className="me-3 text-white">
                                <img src="images/jalistep/in.png" alt="Instagram" className="social-icon" style={{ width: '32px', height: '32px' }} />
                            </a>
                            <a href="#" className="text-white">
                                <img src="images/jalistep/x.png" alt="X" className="social-icon" style={{ width: '32px', height: '32px' }} />
                            </a>
                        
                        <p className="text-white mb-1">Find us on Facebook, Instagram, and X for more details</p>
                        <p className="text-white mb-1">@Jalistep_int on all platforms</p>
                    </div>
                </div>

                {/* Horizontal Divider */}
                <hr className="my-4" style={{ borderColor: '#0dcaf0' }} />

                {/* Copyright Section */}
                <div className="text-center py-2">
                    <p className="mb-0 text-white">
                        Developed by Dennis. &copy; {new Date().getFullYear()} JALISTEP INTERNATIONAL LIMITED. All Rights Reserved
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;